import request from '@/providers/http-service'
const url = `${process.env.VUE_APP_API_DOMAIN}/unified-code`
// const url = 'http://192.168.1.102:8077'
// const url2 = "http://192.168.1.122:8077"
/**
 * 关芯智巡大屏驾驶舱
 * start
 */
// 资源分布-点位及人力部署
export function getResourcePointAndPerson(params) {
  return request({
    url: url + '/gh-managementCockpit/getResourcePointAndPerson',
    method: 'get',
    params
  })
}


// 资源分布-人力部署
export function getResourcePerson(params) {
  return request({
    url: url + '/gh-managementCockpit/getResourcePerson',
    method: 'get',
    params
  })
}

// 资源分布-点位部署
export function getResourcePoint(params) {
  return request({
    url: url + '/gh-managementCockpit/getResourcePoint',
    method: 'get',
    params
  })
}

// 资源分布-处置效率分析-（上报问题（所有）、长期巡查（当天）、孤寡老人巡查（本周）（表头统计+社区维度统计图））
export function getResourceDisposalByType(params) {
  return request({
    url: url + '/gh-managementCockpit/getResourceDisposalByType',
    method: 'get',
    params
  })
}


// 事项分布-长期巡查（类型、巡查问题分布、事项处办分析）
export function getEventTaskLongPatrol(params) {
  return request({
    url: url + '/gh-managementCockpit/getEventTaskLongPatrol',
    method: 'get',
    params
  })
}

// 事项分布-孤寡老人（年龄分布 年龄段社区维度分布）
export function getEventTaskOldPeople(params) {
  return request({
    url: url + '/gh-managementCockpit/getEventTaskOldPeople',
    method: 'get',
    params
  })
}

// 长期巡查趋势-月份维度
export function getLongPatrolMouth(params) {
  return request({
    url: url + '/gh-managementCockpit/getLongPatrolMouth',
    method: 'get',
    params
  })
}

// 孤寡老人趋势-月份维度
export function getOldPeopleMouth(params) {
  return request({
    url: url + '/gh-managementCockpit/getOldPeopleMouth',
    method: 'get',
    params
  })
}

// 时序分析统计
export function extendBigScreenSxfxTj(params) {
  return request({
    url: url + '/extendBigScreen/sxfxTj',
    method: 'get',
    params
  })
}

// 长期巡查任务
export function extendBigScreenCqxxTj(params) {
  return request({
    url: url + '/extendBigScreen/cqxxTj',
    method: 'get',
    params
  })
}

// 孤寡老人巡查
export function extendBigScreenGglrTj(params) {
  return request({
    url: url + '/extendBigScreen/gglrTj',
    method: 'get',
    params
  })
}

// 中间地图统计
export function extendBigScreenMapTj(params) {
  return request({
    url: url + '/extendBigScreen/mapTj',
    method: 'get',
    params
  })
}

// 最近上报问题
export function extendBigScreenLastReportList(params) {
  return request({
    url: url + '/extendBigScreen/lastReportList',
    method: 'post',
    data: params
  })
}


// WEBPACK FOOTER //
// ./src/api/daping.js